import { jsx as _jsx } from "react/jsx-runtime";
import styles from './styles.module.scss';
/** Renders the bulletin board title input */
export function TitleInput({ title, setTitle, readOnly, }) {
    return (_jsx("input", { readOnly: readOnly, className: styles.titleInput, value: title, placeholder: "Write a Title", onChange: (e) => setTitle(e.target.value) }));
}
